<div class="chargeCar" *ngIf="action === Action.START && (waitUserConnectVehicle || waitRemoteRequest)">
    <ion-img class="chargeCar-loader" src="assets/images/gif/loading-car.gif" alt=""></ion-img>
    <p class="ion-text-center">
        <span *ngIf="waitUserConnectVehicle">{{'remote.start.wait.user' | translate}}</span>
        <span *ngIf="!waitUserConnectVehicle">{{'remote.start.wait.remote' | translate}}</span>
    </p>
</div>

